import { connect } from 'react-redux';
import * as examSelectors from 'edrolo/domains/exams/data/selectors';
import QuestionViewTab from './QuestionViewTab';

const mapStateToProps = (state, { exam, question }) => {
  return {
    loadingText: state.exams.get('loadingText'),
    sitting: examSelectors.getSitting(state, exam.get('id')),
    response: examSelectors.getResponse(state, question.get('id')),
  };
};

export default connect(mapStateToProps)(QuestionViewTab);
